import { ChangeEvent, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TextInput from 'components/textInput/textInput';
import { getQueryParams } from 'components/AddCatalogList/helpers';
import Checkbox from 'library/checkbox/checkbox';
import { insertOrRemove } from 'utils/utility/utils';
import { useAllCategoryManagerDetail } from '../helper';
import { IGetEachOption, FilterTypes } from '../type';
import * as Styles from './styles';

interface ICategoryManagerFilterProps {
  onClose(): void;
  onFilterChange(param: Partial<Record<FilterTypes, Array<string>>>): void;
}

const CategoryManagerFilter = ({
  onClose,
  onFilterChange,
}: ICategoryManagerFilterProps) => {
  const { search } = useLocation();
  const categoryManager = useAllCategoryManagerDetail();
  const currentQueryParams = getQueryParams(search);
  const [categoryManagerSearch, setCategoryManagerSearch] = useState('');
  const [list, setCategoryManagerList] =
    useState<Array<IGetEachOption>>(categoryManager);
  const [selectedCheckbox, setSelectedCheckbox] = useState<Array<string>>(
    currentQueryParams?.category_manager__in ?? []
  );

  function handleSearchChange(event: ChangeEvent<HTMLInputElement>) {
    let value = event.target.value;
    setCategoryManagerSearch(value);
    setCategoryManagerList(matchQuery(value, categoryManager));
  }

  function matchQuery(value: string, options: Array<IGetEachOption>) {
    const newCategories: Array<IGetEachOption> = [];
    options.forEach(eachOption => {
      if (eachOption.name.toLowerCase().startsWith(value.toLowerCase())) {
        newCategories.push(eachOption);
      }
    });

    return newCategories;
  }

  function handleCategoryManagerCheck(value: string) {
    const updatedSelectedOptions = insertOrRemove(selectedCheckbox, value);
    setSelectedCheckbox(updatedSelectedOptions);
  }

  function handleApplyFilter() {
    onFilterChange({ category_manager__in: selectedCheckbox });
  }

  function handleClearOption() {
    onFilterChange({ category_manager__in: [] });
  }

  return (
    <Styles.CategoryManagerFilterContainer className="pos-a full-width">
      <Styles.CategoryManagerHeader className="spread">
        <Styles.CategoryManagerHeaderText>
          Category Managers
        </Styles.CategoryManagerHeaderText>
        <Styles.CategoryManagerHeaderClearAll
          className="cursor-pointer"
          onClick={handleClearOption}
        >
          Clear
        </Styles.CategoryManagerHeaderClearAll>
      </Styles.CategoryManagerHeader>
      <Styles.CategoryManagerContainer>
        <TextInput
          placeholder="Search Name"
          onChange={handleSearchChange}
          onClear={() => null}
          value={categoryManagerSearch}
          listItemSearchBoxClass="list-item-search-box-class"
          showCrossButton={false}
        />
      </Styles.CategoryManagerContainer>
      <Styles.CategoryManagerFilterResults className="has-y-scroll">
        {list?.map(item => (
          <Styles.FilterOption key={item.id}>
            <Checkbox
              item={{
                value: item.id,
              }}
              label={item.name}
              onChange={() => handleCategoryManagerCheck(item.id)}
              checked={selectedCheckbox.includes(item.id)}
            />
          </Styles.FilterOption>
        ))}
      </Styles.CategoryManagerFilterResults>
      <Styles.BottomTabButtons className="spread">
        <Styles.ClearButton onClick={onClose}>Cancel</Styles.ClearButton>
        <Styles.ApplyButton
          className="cursor-pointer"
          onClick={handleApplyFilter}
        >
          Apply
        </Styles.ApplyButton>
      </Styles.BottomTabButtons>
    </Styles.CategoryManagerFilterContainer>
  );
};

export default CategoryManagerFilter;
